import axios from 'axios';
import { GET_PROPERTY_ADDRESS, GET_PROPERTY_BY_POSTALCODE } from '../../../config/realstar-api-config';

export const fetchProperty = async (propertyID, encryptedUserID) => {
  const URL = `${GET_PROPERTY_ADDRESS}${encryptedUserID}`;

  const authKey = process.env.REACT_APP_REALSTAR_AUTH_KEY; 
  const rs_code = process.env.REACT_APP_REALSTAR_RS_CODE; 

  const options = {
    method: 'POST',
    url: URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Auth-Key': authKey,
      'RS-Code': rs_code
    },
    data: new URLSearchParams({
      propertyID: propertyID
    }).toString() // Convert URLSearchParams to string
  };

  try {
    const response = await axios(options)

    if (response.status === 200) {
      return response?.data?.result;
    } else {
      return response?.data
    }
  } catch (error) {
    console.log(error)
    throw error;
  }


}



export const fetchPropertyByPostalCode = async (postalCode) => {
  const extension = `&returnGeom=Y&getAddrDetails=Y&pageNum=1`

  const URL = `${GET_PROPERTY_BY_POSTALCODE}${postalCode}${extension}`;

  const options = {
    method: 'GET',
    url: URL,
  };

  try {
    const response = await axios(options)
    const {status, data} = response;

    if (status === 200) {
      if(data?.found > 0){
        if(data?.results.length > 0){
          return data?.results[0]
        }else{
          return data?.results
        }
      }
    }
  } catch (error) {
    console.log(error)
    throw error;
  }


}